// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import POutdentOutlinedSvg from "@fishx/icons-svg/es/asn/POutdentOutlined";
import FishxIcon from '../components/FishxIcon';

var POutdentOutlined = function POutdentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: POutdentOutlinedSvg
  }));
};

POutdentOutlined.displayName = 'POutdentOutlined';
export default React.forwardRef(POutdentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/POutdentOutlined.js
// module id = 3521
// module chunks = 0